import { palette } from './palette';
import background from 'assets/images/faq-banner-img.webp';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: 'unset !important',

      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.dionhealth-container': {
    '& .normal-text': {
      fontWeight: 300,
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        backgroundColor: palette.background.header,
      },

    '& .subscription-wrapper, .checkout-outer-container, .addonsWrapper, .plan-selection-container':
      {
        '& .MuiSwitch-thumb': {
          background: palette.text.highlight,
        },
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
          backgroundColor: palette.secondary.main,
        },
        '& .MuiSwitch-track': {
          border: 'none',
          background: palette.secondary.main,
        },
      },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      backgroundColor:
        'background: linear-gradient(101deg, #C3DFFC 3.17%, rgba(223, 238, 253, 0.48) 49.36%, rgba(238, 246, 254, 0.00) 61.69%, rgba(248, 251, 254, 0.00) 69.02%)',

      '& .hero-background': {
        objectFit: 'cover',
        '@media screen and (max-width: 900px)': {
          height: '340px',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '550px',
      },
      '& .home-hero-title': {
        color: palette.text.primary,
      },
      '& .section-header__subtitle-wrapper': {
        margin: '24px 0px',
      },
      '& .home-hero-subtitle': {
        color: palette.text.primary,
        maxWidth: 510,
      },
    },

    /* Benefits - Styles */
    '& .definition-variant-2': {
      '& .benefits-wrapper': {
        '& section-header__title': {
          weight: '600',
        },
      },
      '& #definition-section': {
        '& .benefits-wrapper': {
          padding: '0 24px',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        background: palette.background.light,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          '& .price-value, .display-frequency': {
            color: palette.secondary.main,
          },
          '&:hover': {
            color: palette.primary.main,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .MuiButton-containedSecondary': {
            '&:hover': {
              opacity: 1,
            },
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.primary,
          },
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
        '& .summary-text, .summary-subtext': {
          color: palette.text.primary,
        },
        '& .savings-summary-link': {
          color: palette.text.alternate,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* FAQ */
    '& .faq-variant2-wrapper': {
      '& .collapseIcon, .expandIcon': {
        color: palette.secondary.main,
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.background.main,

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
        '@media(min-width: 1024px) and (max-width: 1366)': {
          paddingLeft: '10px !important',
        },
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .how-cover-image': {
        backgroundSize: 'cover',
      },

      '& .step-counter': {
        borderRadius: '16%',
        backgroundColor: palette.background.tableAlternate,
        color: palette.text.primary,
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.secondary.main,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 1367px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '100px',
        },
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      background: palette.background.main,

      '@media(min-width: 900px)': {
        padding: 72,
      },

      '& .testimonial-name, & .testimonial-location, & .testimonial-message': {
        color: palette.text.primary,
      },

      '& .testimonialSection': {
        padding: '40px 32px',

        '@media(min-width: 900px)': {
          padding: '40px 16px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .service-plan-table': {
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        backgroundColor: palette.background.footer,
        '& .contact-button': {
          backgroundColor: palette.secondary.main,
        },
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: palette.background.footer,
      },
      '& .primary-static-button': {
        backgroundColor: palette.secondary.main,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.text.highlight,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.secondary.main,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: palette.secondary.main,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '& .price-value, .display-frequency': {
            color: palette.secondary.main,
          },
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.divider,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      backgroundImage: `url(${background})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',

      '& .hero-link-button': {
        backgroundColor: palette.secondary.main,
      },

      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        textAlign: 'left',
      },
      '& .header-container': {
        justifyContent: 'left',
        margin: '0',
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },

    /* Employee */
    '& .employerRootContainer': {
      '& .home-hero-wrapper': {
        '& .hero-section': {
          display: 'flex',
          alignItems: 'center',
          maxHeight: '620px',
        },

        '@media(min-width: 1024px) and (max-width: 1366px)': {
          '& .image': {
            objectPosition: 'center',
          },
          '& .header-subtitle-divider': {
            marginTop: 12,
            marginBottom: 25,
          },
          '& .hero-title': {
            fontSize: 36
          }
        },
        '& .customSubtitleItems': {
          fontSize: 24
        }
      },
      '& .hero-link-button, .login-button': {
        borderRadius: 4,
      },
      '& .section-header__subtitle-wrapper': {
        marginBottom: '40px !important',
        margin: '12px 0px !important',
      },
      '& .hero-subtitle-divider-container': {
        padding: '32px 0px 56px 10px',
        '& .hero-subtitle-divider': {
          maxWidth: 160,
          border: `2px solid ${palette.text.primary}`,
        },
      },
      '& .accordion__item-wrapper': {
        paddingTop: '10px',
        border: 'none !important',
        borderBottom: `1px solid ${palette.divider} !important`,
        borderRadius: '0 !important',
      },
      '@media(min-width: 900px)': {
        '& .home-hero-wrapper': {
          paddingTop: 140,
        },
      },

      /* Definiton */
      '& .section-header__overline-wrapper': {
        fontSize: 18,
        color: palette.text.secondary,
      },

      /* Subscription */
      '& .customSubscriptionWrapper': {
        '& .section-alternate': {
          '@media(min-width: 768px) and (max-width: 1180px)': {
            '& .section-alternate__content': {
              padding: '64px 0px !important',
            },
          },
        },
        '& .customStaticCard': {
          border: `1px solid ${palette.primary.main}`,
          borderRadius: '0px 24px;',
        },
        '@media(min-width: 768px) and (max-width: 1180px)': {
          '& .customCardContainer': {
            maxWidth: '48%',
          },
        },
        '& .customValue': {
          color: palette.secondary.main,
        },
        '& .customStartMembership': {
          borderRadius: 4,
          height: 70,
        },
        '& .MuiSwitch-thumb': {
          background: palette.text.highlight,
        },
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
          backgroundColor: palette.secondary.main,
        },
        '& .MuiSwitch-track': {
          border: 'none',
          background: palette.secondary.main,
        },
      },

      /* Metrics */
      '& .metrics': {
        '& .section-header__title': {
          maxWidth: 600,
        },
        '& .metrics-getstarted-button': {
          borderRadius: 4,
          height: 56,
          width: 187,
        },
      },

      /* Hero Static Footer */
      '& .hero-static-bg': {
        backgroundColor: `${palette.secondary.main} !important`,
      },
      '& .hero-static-section': {
        '& .hero-static-title, .hero-static-subtitle': {
          color: `${palette.text.highlight} !important`,
        },
        '& .primary-static-button': {
          background: palette.text.highlight,
          color: palette.text.primary,
          borderRadius: 4,
        },
      },
      '& .customBar': {
        color: palette.text.highlight
      },
      '& .bar_accordion__item-wrapper': {
        padding: 0
      }
    },
    /* Footer Disclosure */
    '& .footer-wrapper, & .footer-wrapper a': {
      backgroundColor: palette.background.footer,
    },
  },
};
